const hamburger = document.querySelector('#hamburger-container');

hamburger.addEventListener('click', toggleMenu);

function toggleMenu(e) {
    const navmenu = document.querySelector('nav#sidebarMenu ul.menu');
    navmenu.classList.toggle('open');
    this.classList.toggle('open');
}